export default __webpack_public_path__ + "static/media/about-page-img.0c3cf26f.jpg";